// extracted by mini-css-extract-plugin
module.exports = {"accordion":"ud0iv"};